<div class="product-request-view">
  <div class="product-request-view__block">
    <div
      [ngClass]="isDesktop ? 'text_heading-4' : 'text_heading-5'"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      {{ data?.name }}
    </div>

    <app-label [class.tui-skeleton]="loading" [label]="'components.lpProductRequestInfo.fields.location' | translate">
      <app-field
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [typeName]="'new-parse-links'"
        [noUnderline]="true"
        [value]="data?.location"
        [size]="tuiElementMediumSize"
      ></app-field>
    </app-label>

    <app-label
      *ngIf="data?.webLink"
      [class.tui-skeleton]="loading"
      [label]="'components.lpProductRequestInfo.fields.webLink' | translate"
    >
      <app-field
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [typeName]="'new-parse-links'"
        [noUnderline]="true"
        [value]="data?.webLink"
        [size]="tuiElementMediumSize"
      ></app-field>
    </app-label>

    <app-label
      *ngIf="data?.mapLink"
      [class.tui-skeleton]="loading"
      [label]="'components.lpProductRequestInfo.fields.mapLink' | translate"
    >
      <app-field
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [typeName]="'new-parse-links'"
        [noUnderline]="true"
        [value]="data?.mapLink"
        [size]="tuiElementMediumSize"
      ></app-field>
    </app-label>

    <app-label
      *ngIf="data?.reasonText"
      [class.tui-skeleton]="loading"
      [label]="'components.lpProductRequestInfo.fields.reasonText' | translate"
    >
      <app-field
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [typeName]="'new-parse-links'"
        [noUnderline]="true"
        [value]="data?.reasonText"
        [size]="tuiElementMediumSize"
      ></app-field>
    </app-label>

    <app-label
      *ngIf="data?.managerContact"
      [class.tui-skeleton]="loading"
      [label]="'components.lpProductRequestInfo.fields.manager' | translate"
    >
      <app-field
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [typeName]="'new-parse-links'"
        [noUnderline]="true"
        [value]="data?.managerContact"
        [size]="tuiElementMediumSize"
      ></app-field>
    </app-label>

    <app-field
      *ngIf="data?.readyToPromote"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [typeName]="'new-parse-links'"
      [noUnderline]="true"
      [value]="'components.lpProductRequestInfo.fields.readyToPromote' | translate"
      [size]="tuiElementMediumSize"
    ></app-field>

    <app-label
      *ngIf="data?.userContactsText"
      [class.tui-skeleton]="loading"
      [label]="'components.lpProductRequestInfo.fields.userContactsText' | translate"
    >
      <app-field
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [typeName]="'new-parse-links'"
        [noUnderline]="true"
        [value]="data?.userContactsText"
        [size]="tuiElementMediumSize"
      ></app-field>
    </app-label>
  </div>

  <div *ngxPermissionsOnly="['loyaltyProgramProductRequestInfoViewing']" class="product-request-view__block">
    <div class="text_bold text_size-{{ tuiElementMediumSize }}">
      {{ 'components.lpProductRequestInfo.labels.fullInfo' | translate }}
    </div>

    <app-label [class.tui-skeleton]="loading" [label]="'components.lpProductRequestInfo.fields.status' | translate">
      <app-field
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [typeName]="'new-parse-links'"
        [noUnderline]="true"
        [value]="data?.status | getStatusText"
        [size]="tuiElementMediumSize"
      ></app-field>
    </app-label>

    <app-label
      *ngIf="data?.parentOrganisationName"
      [class.tui-skeleton]="loading"
      [label]="'components.lpProductRequestInfo.fields.parentOrganisationName' | translate"
    >
      <app-field
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [typeName]="'new-parse-links'"
        [noUnderline]="true"
        [value]="data?.parentOrganisationName"
        [size]="tuiElementMediumSize"
      ></app-field>
    </app-label>

    <app-label
      *ngIf="data?.organisationName"
      [class.tui-skeleton]="loading"
      [label]="'components.lpProductRequestInfo.fields.organisationName' | translate"
    >
      <app-field
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [typeName]="'new-parse-links'"
        [noUnderline]="true"
        [value]="data?.organisationName"
        [size]="tuiElementMediumSize"
      ></app-field>
    </app-label>
  </div>

  <div *ngIf="data?.changes?.length">
    <div class="text_bold text_size-{{ tuiElementMediumSize }}">
      {{ 'components.lpProductRequestInfo.labels.changes' | translate }}
    </div>

    <product-request-changes [items]="data?.changes" [creatorId]="data?.userId"></product-request-changes>
  </div>
</div>
